import React from 'react';
import { useState } from 'react';
import * as Const from '../../utils/Const';
import { GetOrgId, formatDateToString } from '../../utils/UtilFunction';
import useAxios from 'axios-hooks';
import { getAuthHeader } from '../dashboard/api/fetchData';
import DatadownloadView from './DatadownloadView';
import { AxiosError } from 'axios';

export function DatadownloadContainer() {
  const defaultFromDateObj = new Date();
  defaultFromDateObj.setMonth(defaultFromDateObj.getMonth() - 1);
  defaultFromDateObj.setHours(0, 0, 0, 0);
  const defaultFromDate = defaultFromDateObj;
  const defaultToDate = new Date().setHours(23, 59, 59, 999);
  const [fromDate, setFromDate] = useState<Date | null>(new Date(defaultFromDate));
  const [toDate, setToDate] = useState<Date | null>(new Date(defaultToDate));

  const [selectedCsvTypes, setSelectedCsvTypes] = useState<string[]>([]);
  const [downloadErrorMessage, setDownloadErrorMessage] = useState<string>('');
  const downloadDataUrl = `${import.meta.env.VITE_DATA_POOLS_URL}/selectDownloadCSVData`;
  const orgId = GetOrgId();

  const dataParams = {
    [Const.KeyOrgID]: orgId,
    [Const.KeyTmStartTimeUtcFrom]: fromDate?.toJSON() || '',
    [Const.KeyTmStartTimeUtcTo]: toDate?.toJSON() || '',
    [Const.KeyDownloadType]: selectedCsvTypes,
  };

  const [, executeDownload] = useAxios(
    { url: downloadDataUrl, method: 'POST', data: dataParams, responseType: 'blob' },
    { manual: true }
  );

  const handleDownload = async () => {
    if (selectedCsvTypes.length === 0) {
      setDownloadErrorMessage(Const.ErrorMessageCSVDownloadTarget);
      return;
    }
    if (fromDate && toDate && fromDate > toDate) {
      setDownloadErrorMessage(Const.ErrorMessageCSVDownloadDateRange);
      return;
    }

    try {
      setDownloadErrorMessage('');
      const headers = await getAuthHeader();
      const response = await executeDownload({ headers });

      const blob = response.data as Blob;
      const contentDisposition = response.headers['content-disposition'];
      const filename =
        contentDisposition?.match(/filename="?(.+)"?/)?.[1] ||
        'vrl-dashboard_' + formatDateToString() + '.zip';

      // ダウンロード処理
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response && error.response.data) {
        if (error.response.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            const json = JSON.parse(reader.result as string);
            setDownloadErrorMessage(json.message);
          };
          reader.readAsText(error.response.data);
        }
        return;
      }
      setDownloadErrorMessage(error instanceof Error ? error.message : String(error));
    }
  };

  return (
    <>
      <DatadownloadView
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        selectedCsvTypes={selectedCsvTypes}
        setSelectedCsvTypes={setSelectedCsvTypes}
        handleDownload={handleDownload}
        downloadErrorMessage={downloadErrorMessage}
      />
    </>
  );
}

export default DatadownloadContainer;
